import React, { FC, ReactNode, HTMLAttributes } from 'react'
import { StyledParagraph } from './Paragraph.style'
import { ICentraThemeColors } from 'components/styles/variables'

export interface IText {
  children?: ReactNode
  size?: 'sm' | 'lg'
  weight?: 'bold'
  align?: 'left' | 'center' | 'right'
  color?: keyof ICentraThemeColors
  uppercase?: boolean
  underline?: boolean
  ellipsis?: boolean
  nowrap?: boolean
  marginTop?: number
  marginBottom?: number
}

const Paragraph: FC<IText & HTMLAttributes<HTMLParagraphElement>> = (props: IText) => {
  return <StyledParagraph {...props}>{props.children}</StyledParagraph>
}

export default Paragraph
